import { useState } from 'react';
import { Link } from '../routing';
import { authApi } from '../utils/api';
import * as S from './authStyles';

// "שכחתי סיסמה" entry point. POSTs the email and shows the server's outcome:
// a success message when a reset mail was sent, or a specific error (e.g. no
// account with that address) so a real user isn't left stuck with no feedback.
export default function ForgotPasswordPage() {
  const [email, setEmail]     = useState('');
  const [sent, setSent]       = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const { data } = await authApi.forgotPassword(email.trim());
      setMessage(data?.message || '');
      setSent(true);
    } catch (err) {
      setError(
        err?.response?.data?.error ||
        'אירעה שגיאה. נסו שוב מאוחר יותר או פנו למי שמנהל את המערכת אצלכם.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={S.container}>
      <div style={S.card}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: '1.4rem', fontWeight: 800, color: S.colors.primary }}>איפוס סיסמה</div>
          <div style={{ fontSize: '0.85rem', color: S.colors.muted, marginTop: 6 }}>
            נשלח אליך מייל עם קישור לאיפוס הסיסמה
          </div>
        </div>

        {sent ? (
          <>
            <div role="status" style={S.successBox}>
              {message ? (
                message
              ) : (
                <>
                  שלחנו אליך מייל עם קישור לאיפוס הסיסמה (תקף לשעה).<br />
                  לא הגיע? בדקו את תיקיית הספאם, או פנו למי שמנהל את המערכת אצלכם.
                </>
              )}
            </div>
            <Link to="/login" style={{ ...S.link, display: 'block', textAlign: 'center', fontSize: '0.9rem', fontWeight: 600 }}>
              חזרה להתחברות
            </Link>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && (
              <div role="alert" style={S.errorBox}>
                {error}
              </div>
            )}
            <div style={{ marginBottom: 18 }}>
              <label htmlFor="email" style={S.label}>
                אימייל
              </label>
              <input
                id="email"
                name="email"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
                inputMode="email"
                required
                style={S.input}
                {...S.inputFocusHandlers}
                {...S.validationHandlers}
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              aria-busy={loading}
              style={S.button(loading)}
              {...S.buttonHoverHandlers}
            >
              {loading ? 'שולחים…' : 'שליחת קישור'}
            </button>
            <div style={{ textAlign: 'center', marginTop: 16 }}>
              <Link to="/login" style={S.link}>
                חזרה להתחברות
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
